import { render, staticRenderFns } from "./Nativepay.vue?vue&type=template&id=314355b3&scoped=true&"
import script from "./Nativepay.vue?vue&type=script&lang=js&"
export * from "./Nativepay.vue?vue&type=script&lang=js&"
import style0 from "./Nativepay.vue?vue&type=style&index=0&id=314355b3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314355b3",
  null
  
)

export default component.exports